import { FunctionComponent } from 'react'

import ConfirmContactWrapper from '../../components/ConfirmContactWrapper'
import { IMMEDIATE_ATTENDANCE } from '@/modules/Attendance/constants'

const ScreeningConfirmContact: FunctionComponent = () => {
  return <ConfirmContactWrapper attendanceType={IMMEDIATE_ATTENDANCE} />
}

export default ScreeningConfirmContact
